import React, { useEffect } from 'react';
import styled from 'styled-components';
import * as cons from '../../constants';
import * as colors from '../../colors';
import { CustomScrollCss } from '../../styled/scroll/CustomScroll';
import { IconSets } from './IconSets';
function Modal({ closeModal, modalVisible, children, maxWidth, hideCloseBtn, positionTop, disableCloseBtn, }) {
    function onMouseDownOverlay(event) {
        if (!disableCloseBtn && event.clientX < document.documentElement.offsetWidth - 15) {
            closeModal?.();
        }
    }
    useEffect(() => {
        if (modalVisible) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [modalVisible]);
    return (React.createElement(Overlay, { modalVisible: modalVisible, onMouseDown: onMouseDownOverlay, positionTop: positionTop },
        React.createElement(ModalWindow, { onMouseDown: (e) => e.stopPropagation(), modalVisible: modalVisible, maxWidth: maxWidth, positionTop: positionTop },
            !hideCloseBtn && !disableCloseBtn && (React.createElement(ModalCloseButton, { onClick: closeModal },
                React.createElement(IconSets, { name: "Close", className: "!w-[20px] !h-[20px] text-black/30" }))),
            React.createElement(Container, null, children))));
}
const Overlay = styled.div `
  background-color: rgba(0, 0, 0, 0.4);
  /* opacity: 0; */
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  // background-color: rgba(0,0,0,.2);
  z-index: 10000000000;
  display: none;
  ${(props) => props.modalVisible &&
    `
    pointer-events: auto;

    display: flex;
  justify-content: center;
  align-items: center;
	`}
  transition: 0.2s all ease-in;

  overflow: scroll;
  overflow-x: hidden;
  padding: 48px 0px 58px 0px;
  box-sizing: border-box;

  ${(props) => props.positionTop &&
    `
    align-items: flex-start;
  `}

  ${CustomScrollCss}
`;
const ModalWindow = styled.div `
  color: ${colors.FONT_PRIMARY};
  border-radius: 8px;
  z-index: 10000000001;
  background-color: white;
  position: relative;
  max-width: ${(props) => props.maxWidth}px;
  width: 95%;
  z-index: 100000000000000000000000000;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  /* margin-top: 20px; */
  transition: 0.2s all ease-in;
  transform: translateY(20px);
  // box-shadow: 0px 4px 8px rgba(0,0,0,.1);
  // box-shadow: 0 4px 6px rgba(0,0,0,.2), 0 12px 12px rgba(0,0,0,.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15),
    0 3px 6px rgba(0, 0, 0, 0.1);
  /* display: none; */
  overflow: hidden;
  display: none;

  ${(props) => (props.positionTop ? '' : 'margin:auto;')}

  ${(props) => props.modalVisible &&
    `
    display: block;
	`}
`;
const Container = styled.div `
  position: relative;
  max-width: ${cons.MAX_WIDTH}px;
  margin: auto;
`;
const ModalCloseButton = styled.button `
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 10000000000;
  background-color: transparent;
  border: none;
  cursor: pointer;
  /* padding: 10px; */
  margin: 0;
  width: 34px;
  height: 34px;
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
`;
export default Modal;
